import axios from 'axios';
import { getDeviceId } from '../utils/device-info.util';
import { getLocalValue } from '../utils/local-cache.util';
import { LS_ADMIN_USER_AUTH_TOKEN } from '../config/const.config';

const prepareRequestOptions = (url, method, data = null) => {
  const baseAPIUrl = process.env.REACT_APP_CMS_API_ENDPOINT;
  const uuid = getDeviceId();
  const adminAuth = getLocalValue(LS_ADMIN_USER_AUTH_TOKEN);

  const options = {
    url: `${baseAPIUrl}${url}`,
    method,
    headers: {
      'Content-Type': 'application/json',
      'X-Req-Device': uuid,
      'X-Admin-Auth-Token': adminAuth,
    },
    data: JSON.stringify(data || {}),
  };

  return options;
};

export const assignMovie = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/categories/${id}/assign-movie`,
    'POST',
    payload,
    true
  );
  const response = await axios(options);
  return response.data;
};

export const viewMoviesById = async (id, params = '') => {
  const options = prepareRequestOptions(
    `/admin/categories/${id}/viewMovies${params}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteAssignedMovieById = async (id, movieId) => {
  const options = prepareRequestOptions(
    `/admin/categories/${id}/assigned-movie/${movieId}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const assignSeries = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/categories/${id}/assign-series`,
    'POST',
    payload,
    true
  );
  const response = await axios(options);
  return response.data;
};

export const viewSeriesById = async (id, params = '') => {
  const options = prepareRequestOptions(
    `/admin/categories/${id}/viewSeries${params}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteAssignedSeriesById = async (id, movieId) => {
  const options = prepareRequestOptions(
    `/admin/categories/${id}/assigned-series/${movieId}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const assignShow = async (id, payload) => {
    const options = prepareRequestOptions(
      `/admin/categories/${id}/assign-shows`,
      'POST',
      payload,
      true
    );
    const response = await axios(options);
    return response.data;
  };
  
  export const viewShowById = async (id, params = '') => {
    const options = prepareRequestOptions(
      `/admin/categories/${id}/viewShows${params}`,
      'GET',
      null,
      true
    );
  
    const response = await axios(options);
    return response.data;
  };
  
  export const deleteAssignedShowById = async (id, movieId) => {
    const options = prepareRequestOptions(
      `/admin/categories/${id}/assigned-shows/${movieId}/delete`,
      'DELETE',
      null,
      true
    );
  
    const response = await axios(options);
    return response.data;
  };

export const getSearchListMovies = async (adminUserId) => {
  const options = prepareRequestOptions(
    `/admin/videos/search-list/${adminUserId}`,
    'GET'
  );

  const response = await axios(options);
  return response.data;
};

export const getSearchListSeries = async (adminUserId) => {
  const options = prepareRequestOptions(
    `/admin/series/search-list/${adminUserId}`,
    'GET'
  );

  const response = await axios(options);
  return response.data;
};

export const getSearchListShows = async (adminUserId) => {
  const options = prepareRequestOptions(
    `/admin/show/search-list/${adminUserId}`,
    'GET'
  );

  const response = await axios(options);
  return response.data;
};

export const updateCategoryContentSequence = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/sequence/content-category/update',
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};